import { createListenerMiddleware, isAnyOf, PayloadAction, TypedStartListening } from '@reduxjs/toolkit';

import { authApi } from '../api';
import { loginThunk, logoutThunk } from '../thunks';
import { AuthStoreDispatch, AuthStoreState, TAuthResponseBody } from '../types';

export const authMiddleware = createListenerMiddleware();

type TAppStartListening = TypedStartListening<AuthStoreState, AuthStoreDispatch>;
const startAppListening = authMiddleware.startListening as TAppStartListening;

const { logoutUser, loginUser, refreshToken } = authApi.endpoints;

startAppListening({
    matcher: isAnyOf(refreshToken.matchFulfilled, loginUser.matchFulfilled),
    effect: ({ payload: { accessToken } }: PayloadAction<TAuthResponseBody>, { dispatch }) => {
        dispatch(loginThunk(accessToken));
    },
});

startAppListening({
    matcher: refreshToken.matchRejected,
    effect: ({ meta: { condition } }, { dispatch }) => {
        // If the condition meta data is true, it means the request was made with a condition that failed.
        // In this case, we do not want to log out the user.
        if (condition) return;
        dispatch(logoutThunk());
    },
});

startAppListening({
    matcher: logoutUser.matchFulfilled,
    effect: (_, { dispatch }) => {
        dispatch(logoutThunk());
    },
});
